{
	"title": "Déclarations",
	"table": {
		"material": "Matériau",
		"dateOfIssue": "Date d’émission",
		"quantity": "Quantité",
		"carbonSavings": "Réductions de carbone",
		"status": {
			"title": "Statut",
			"TransactionProcessing": "Traitement de la transaction",
			"CreatingDeclaration": "Création de la déclaration",
			"GenerationFailed": "Échec de la génération",
			"ReadyToDownload": "Prêt à télécharger"
		}
	},
	"declarationLanguageSelect": {
		"title": "Langue de la déclaration",
		"description": "Sélectionnez une langue pour la déclaration.",
		"label": "Langue de la déclaration",
		"buttonBack": "Retour",
		"buttonSave": "Enregistrer"
	},
	"downloadAllLanguageSelect": {
		"title": "Langues des déclarations",
		"descriptionGlobal": "Sélectionnez une langue pour toutes les déclarations.",
		"descriptionIndividual": "Ou définissez la langue pour chaque déclaration individuellement.",
		"label": "Langues des déclarations",
		"tableHeaderDeclaration": "Déclaration (matériau/date d'émission)",
		"tableHeaderLanguage": "Langue de la déclaration",
		"buttonBack": "Retour",
		"buttonDownload": "Télécharger les déclarations"
	},
	"declarationActions": {
		"changeLanguage": "Modifier la langue de la déclaration",
		"preview": "Aperçu",
		"download": "Télécharger",
		"transaction": "Transaction",
		"showMoreTransactions": "Afficher plus de transactions",
		"languageLabel": "Langue de la déclaration",
		"downloadAll": "Télécharger toutes les déclarations"
	}
}
